module.exports = __webpack_public_path__ + "img/education.2fed1c09.svg";